<template>
  <b-row class="gallery-body">
    <b-col
      v-for="album in albumList"
      :id="`album-${album.id}`"
      :key="album.id"
      cols="6"
      md="4"
      xl="3"
      class="album-item mb-3"
      tabindex="0"
      role="button"
      :aria-label="album.title"
      :title="album.title"
      @click="!selectMode ? onOpenAlbum(album) : onSelectAlbum(album)"
      @keydown.enter="!selectMode ? onOpenAlbum(album) : onSelectAlbum(album)"
    >
      <div class="gallery-thumbnail" :class="parent">
        <template v-if="!isGroupParent">
          <badge-notification
            v-if="album.id == null"
            :show-exclamation-icon-instead-of-amount="calculateBadges(album.id) > 0"
            :border="true"
          />
          <badge-notification v-else :amount="calculateBadges(album.id)" :border="true" />
        </template>
        <AlbumCard :album="album" :show-select-box="selectMode" />
      </div>
    </b-col>
    <b-col>
      <aula-spinner v-if="isLoading" />
    </b-col>
  </b-row>
</template>

<script>
import BadgeNotification from '../../components/BadgeNotification.vue';
import AlbumCard from './AlbumCard.vue';
import { notificationEventTypes } from '../../enums/notificationEventTypes';
import { notificationTypes } from '../../enums/notificationTypes';
import { parentTypes } from '../../enums/parentTypes';

export default {
  name: 'AlbumList',
  components: {
    BadgeNotification,
    AlbumCard,
  },
  props: {
    albumList: { type: Array, default: () => [] },
    selectMode: { type: Boolean, default: false },
    parent: { type: String, default: parentTypes.GALLERY },
    isGroupParent: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    notifications: { type: Array, default: () => [] },
  },
  emits: ['onOpenAlbum', 'onSelectAlbum'],
  methods: {
    calculateBadges(albumId) {
      return this.notifications.filter(
        notification =>
          (notification.albumId === albumId &&
            notification.notificationEventType !== notificationEventTypes.MEDIA_ADDED_TO_ALBUM) ||
          (albumId === null &&
            notification.notificationEventType === notificationEventTypes.TAGGED_IN_MEDIA &&
            notification.notificationType === notificationTypes.BADGE)
      ).length;
    },
    onOpenAlbum(album) {
      this.$emit('onOpenAlbum', album);
    },
    onSelectAlbum(album) {
      this.$emit('onSelectAlbum', album);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '../../../shared/assets/scss/components/gallery/gallery' as *;

.gallery-thumbnail ::v-deep {
  .badge-notification {
    right: 16px;
    top: 16px;
    z-index: 1;
  }
}
</style>
